import { createFileRoute } from "@tanstack/react-router";
import { ProjektassistancePage, projektassistanceHead } from "@/pages/ProjektassistancePage";

export const Route = createFileRoute("/projektassistance")({
  head: () => projektassistanceHead("da"),
  component: () => <ProjektassistancePage locale="da" />,
});
